import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, CircleIcon, HStack, Text, VStack, useTheme } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Avatar from "../atoms/Avatar/Avatar";
import Badge from "../atoms/Badge";
const AvatarTexts = ({ source, size = "md", label, subText, initials, isCircle = true, status, statusText = "", hasStatusBadge = false, hasAvatar = true, }) => {
    var _a;
    const { fontSizes } = useTheme();
    const { t } = useTranslation();
    const statuses = {
        active: t("active"),
        inactive: t("inactive"),
    };
    const variants = useMemo(() => ({
        "2xs": {
            labelSize: fontSizes.sm,
            lineHeight: 20,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        xs: {
            labelSize: fontSizes.sm,
            lineHeight: 20,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        sm: {
            labelSize: fontSizes.sm,
            lineHeight: 20,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        md: {
            labelSize: fontSizes.sm,
            lineHeight: 20,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        lg: {
            labelSize: fontSizes.md,
            lineHeight: 1,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        xl: {
            labelSize: fontSizes.md,
            lineHeight: 24,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        "2xl": {
            labelSize: fontSizes.md,
            lineHeight: 24,
            subTextSize: fontSizes.xs,
            subtextLineHeight: 18,
        },
        "3xl": {
            labelSize: isCircle ? fontSizes["2xl"] : fontSizes.lg,
            lineHeight: 26,
            subTextSize: fontSizes.sm,
            subtextLineHeight: 20,
        },
    }), [fontSizes, isCircle]);
    return (_jsxs(HStack, Object.assign({ alignItems: "center", maxWidth: "full" }, { children: [hasAvatar && (_jsx(Box, Object.assign({ mr: !label ? "0" : undefined }, { children: _jsx(Avatar, { source: source, initials: initials, size: size, isCircle: isCircle, status: !hasStatusBadge ? status : undefined }) }))), label && (_jsxs(VStack, Object.assign({ flex: "1", alignItems: "flex-start", justifyContent: "center" }, { children: [_jsx(Text, Object.assign({ fontSize: variants[size].labelSize, numberOfLines: 2 }, { children: label })), subText && !["2xs", "xs", "sm"].includes(size) && (_jsx(Text, Object.assign({ color: "gray.600", lineHeight: variants[size].labelSize, fontWeight: "500", fontSize: (_a = variants[size].subTextSize) !== null && _a !== void 0 ? _a : fontSizes.xs }, { children: subText }))), status && hasStatusBadge && (_jsx(Badge, Object.assign({ mt: 2, size: "sm", variant: `ghost${status === "active" ? "Success" : "Error"}` }, { children: statuses[status] }))), statusText && ["2xl", "3xl"].includes(size) && (_jsxs(HStack, Object.assign({ alignItems: "center", width: "100%", mt: subText ? 2.5 : undefined }, { children: [_jsx(CircleIcon, { size: "1.5", mr: "1" }), _jsx(Text, Object.assign({ color: "gray.500" }, { children: statusText }))] })))] })))] })));
};
export default AvatarTexts;
